import { useRef, useState } from "react";

import BuilderOverlay from "./ChartBuilderModal";
import { GetWSMgr } from "@/Utils/StateLib";
import { useTopic } from "@/hooks/useTopic";
import { useWSMgrContext } from "@/providers/WsMgrProvider";

export const ChartBuilder = () => {
  const {
    builderContextValue: {
      initialSettings,
      showBuilder,
      openBuilder,
      closeBuilder,
      createCustomChart
    }
  } = useWSMgrContext();

  const hasBuildStarted = useRef(false);
  const [hasFilterError, setHasFilterError] = useState(false);

  const handleCreate = builderInfo => {
    hasBuildStarted.current = true;
    createCustomChart(builderInfo);
  };

  useTopic("noMatchingRecords", doc => {
    if (!hasBuildStarted.current) {
      return;
    }

    // Switch back to base chart in case the user abandons the custom chart build
    const wsMgr = GetWSMgr();
    wsMgr.SwitchToMasterChart(doc.GetChartID());

    setHasFilterError(true);
    openBuilder();
  });

  useTopic("chartDocumentLoaded", doc => {
    hasBuildStarted.current = false;
    if (!doc.IsServerChart()) {
      setHasFilterError(false);
    }
  });

  const handleClose = () => {
    closeBuilder();
    setHasFilterError(false);
  };

  return (
    <BuilderOverlay
      show={showBuilder}
      onCreate={handleCreate}
      onClose={handleClose}
      hasFilterError={hasFilterError}
      initialSettings={initialSettings}
    />
  );
};
